import React from 'react';
import {Box, Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField} from '@mui/material';
import {ColorPresetType, DirectionChange, LightPathType, LightShape, TherapyState} from '../therapy-configuration';
import "./TherapyForm.css";
import {RootState} from "../../../../store";
import {useDispatch, useSelector} from "react-redux";
import {
    initialState,
    setColorPreset,
    setCycles,
    setDirectionChange,
    setLightPath,
    setLightShape,
    setLightSize,
    setSets,
    setSpeed,
    setState,
    setTherapyConfiguration
} from "../therapyConfigurationSlice";
import {stopTimer} from "../interaction/calculate-light-position";
import SpeedControl from "../speed-control/SpeedControl";
import {useTranslation} from "react-i18next";
import YellowButton from "../../../common/buttons/YellowButton";
import SecondaryButton from "../../../common/buttons/SecondaryButton";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

interface TherapyFormProps {
    isClientJoined:boolean;
    setIsClientJoined:any;
    previewControl:any,
}

const TherapyForm: React.FC<TherapyFormProps> = ({isClientJoined, setIsClientJoined, previewControl}) => {
/*    const [therapyConfiguration, setTherapyConfiguration] = useState<TherapyConfiguration>({
        speed: 1,
        sets: 1,
        cycles: 1,
        state: TherapyState.stopped,
        directionChange: DirectionChange.smooth,
        lightSize: 1,
        lightShape: LightShape.round,
        lightPath: LightPathType.top,
        showPreview: true
    });*/
    const {t} = useTranslation();

    const therapyConfiguration = useSelector((state: RootState) => state.therapyConfiguration);
    const dispatch = useDispatch();

    const setSpeedChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = event.target;
        dispatch(setSpeed(parseInt(value)));
    }


    const setLightSizeChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = event.target;
        let theValue = parseInt(value);
        if(parseInt(value) > 5) {
            theValue = 5;
        }
        if(parseInt(value)<=0) {
            theValue = 1;
        }
        dispatch(setLightSize(theValue));
    }

/*    const setSetsChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = event.target;
        dispatch(setSets(parseInt(value)));
    }

    const setCyclesChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = event.target;
        dispatch(setCycles(parseInt(value)));
    }*/
    const setLightShapeChange = (event: SelectChangeEvent) => {
        const { name, value } = event.target;
        //@ts-ignore
        dispatch(setLightShape(value));
    }
    const setDirectionChangeChange = (event: SelectChangeEvent) => {
        const { name, value } = event.target;
        //@ts-ignore
        dispatch(setDirectionChange(value));
    }
    const setStateChange = (event: SelectChangeEvent) => {
        const { name, value } = event.target;
        //@ts-ignore
        dispatch(setState(value));
    }
    const setLightPathChange = (event: SelectChangeEvent) => {
        const { name, value } = event.target;
        //@ts-ignore
        dispatch(setLightPath(value));
    }

    const setPresetColourChange = (event: SelectChangeEvent) => {
        const { name, value } = event.target;
        //@ts-ignore
        dispatch(setColorPreset(value));
    }
    const restartSets = () => {
        dispatch(setSets(0));
        dispatch(setCycles(0));
        // therapyConfiguration.sets
    }
    /*const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = event.target;
        setTherapyConfiguration(prevConfig => ({
            ...prevConfig,
            [name]: Number(value),
        }));
        dispatch()
    };

    const handleSelectChange = (event: SelectChangeEvent) => {
        const { name, value } = event.target;
        setTherapyConfiguration(prevConfig => ({
            ...prevConfig,
            [name as string]: value,
        }));
    };*/

    const handleStartMovement = () => {
        // Implement the logic to start the therapy session
        // console.log('Therapy session started with configuration:', therapyConfiguration);
        dispatch(setState(TherapyState.inProgress));
    };
    const handleStopMovement = () => {
        // Implement the logic to start the therapy session
        // console.log('Therapy session started with configuration:', therapyConfiguration);
        dispatch(setState(TherapyState.stopped));
        stopTimer();
    };
    const resetToDefault = () => {
        const stateToReset = {
            ...initialState,
            // Do not reset progress counters.
            sets: therapyConfiguration.sets,
            cycles: therapyConfiguration.cycles,
        };
        dispatch(setTherapyConfiguration(stateToReset));
    }
    return (
        <div className={"therapy-form"}>
            <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Box sx={{ display: 'flex', gap: 1 }} className={"top-row-3-elements"}>
                    <FormControl>
                        <InputLabel shrink>{t("Direction")}</InputLabel>
                        <Select
                            name="directionChange"
                            value={therapyConfiguration.directionChange}
                            onChange={setDirectionChangeChange}
                            label={t("Direction Change")}
                        >
                            {Object.values(DirectionChange).map(direction => (
                                <MenuItem key={direction} value={direction}>{t(direction)}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl sx={{ minWidth: 80 }}>
                        <InputLabel shrink>{t("Shape")}</InputLabel>
                        <Select
                            name="lightShape"
                            value={therapyConfiguration.lightShape}
                            onChange={setLightShapeChange}
                            label={t("Light Shape")}
                        >
                            {Object.values(LightShape).map(shape => (
                                <MenuItem key={shape} value={shape}>{t(shape)}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl sx={{ minWidth: 80 }}>
                        <InputLabel shrink>{t("Colour")}</InputLabel>
                        <Select
                            name="colorPreset"
                            value={therapyConfiguration.colorPreset}
                            onChange={setPresetColourChange}
                            label={t("Colour Presets")}
                        >
                            {Object.values(ColorPresetType).map(preset => (
                                <MenuItem key={preset} value={preset}>{t(preset)}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                        label={t("Speed")}
                        type="number"
                        name="speed"
                        inputProps={{ min: 1, max: 20 }}
                        value={therapyConfiguration.speed}
                        onChange={setSpeedChange}
                    />
                    <TextField
                        label={t("Light Size")}
                        type="number"
                        name="lightSize"
                        inputProps={{ min: 1, max: 5 }}
                        value={therapyConfiguration.lightSize}
                        onChange={setLightSizeChange}
                    />
                </Box>
                <SpeedControl />
               {/* <Box sx={{ display: 'flex', gap: 2 }}>
                    <FormControl sx={{ minWidth: 120 }}>
                        <InputLabel shrink>State</InputLabel>
                        <Select
                            name="state"
                            value={therapyConfiguration.state}
                            onChange={setStateChange}
                            label="State"
                        >
                            {Object.values(TherapyState).map(state => (
                                <MenuItem key={state} value={state}>{state}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl sx={{ minWidth: 180 }}>
                        <InputLabel shrink>Light Path</InputLabel>
                        <Select
                            name="lightPath"
                            value={therapyConfiguration.lightPath}
                            onChange={setLightPathChange}
                            label="Light Path"
                        >
                            {Object.values(LightPathType).map(path => (
                                <MenuItem key={path} value={path}>{path}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>*/}
                {previewControl}
                <Box sx={{ display: 'flex', gap: 2 }}>
                    {therapyConfiguration.state === TherapyState.inProgress ?
                        <YellowButton variant="contained" color="primary" onClick={handleStopMovement}
                                style={{ flexGrow: 1, backgroundColor:"orange" }}
                        >
                            Stop
                        </YellowButton>
                    :
                        <YellowButton variant="contained"
                                // sx={{ backgroundColor: '#54b788', '&:hover': { backgroundColor: '#449a6b' }, width: "70%" }}
                                style={{ flexGrow: 1 }}
                                onClick={handleStartMovement}>
                            {isClientJoined ? t("Start Movement") : t("Test Movement")}
                        </YellowButton>
                    }
                    <SecondaryButton variant="contained" color="secondary"
                            disableElevation
                            startIcon={<RestartAltIcon />}
                            aria-label={t("Reset to default")}
                            title={t("Reset to default")}
                            style={{ flexShrink: 0, whiteSpace: 'nowrap' }}
                            onClick={resetToDefault}>
                        {t("Reset")}
                    </SecondaryButton>
                </Box>
            </Box>

            <br />
            <div style={{visibility: (isClientJoined?"visible" : "hidden")}}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                        label={t("Sets")}
                        type="number"
                        name="sets"
                        disabled={true}
                        inputProps={{ min: 0, max: 100 }}
                        value={therapyConfiguration.sets}
                    />
                    <TextField
                        label={t("Cycles")}
                        type="number"
                        name="cycles"
                        disabled={true}
                        inputProps={{ min: 0, max: 100 }}
                        value={therapyConfiguration.cycles < 0 ? 0 : therapyConfiguration.cycles}
                    />
                </Box>
                <div className={"reset-sets-counter"} onClick={restartSets}>{t("restart sets")}</div>
            </div>
        </div>
    );
};

export default TherapyForm;
